import { render, staticRenderFns } from "./CreateProfile.vue?vue&type=template&id=76561838&"
import script from "./CreateProfile.vue?vue&type=script&lang=js&"
export * from "./CreateProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76561838')) {
      api.createRecord('76561838', component.options)
    } else {
      api.reload('76561838', component.options)
    }
    module.hot.accept("./CreateProfile.vue?vue&type=template&id=76561838&", function () {
      api.rerender('76561838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/register/steps/CreateProfile.vue"
export default component.exports